import React, { Component, createRef } from 'react';
import { Example, Properties, SourceCode, Tip } from 'examples';
import Button from '../Button/Button';
import Checkbox from '../Checkbox/Checkbox';
import Table from './Table';
import TableSelectionHandler from './TableSelectionHandler';
import Input from '../Input/Input'

class TableExample extends Component {

  constructor(props) {
    super(props);
    this.refCell = createRef();
    this.state = {
      __editable: false,
      className: 'scrollable',
      columns: ['name', 'address', 'e-mail'],
      items: this.createItems(),
      selection: {},
      selectionType: TableSelectionHandler.SINGLE,
    };
    this.onKeyUp = this.onKeyUp.bind(this);
  }

  onChange = e => this.setState(e.target.value);

  onChangeEditable = e => this.setState({ __editable: !this.state.__editable });

  onClearSelection = e => e.target.dataset.clearselection &&this.setState({ selection: TableSelectionHandler.clearSelection() });

  onClick = e => window.showAppInfo(e.target.value.name);

  onDoubleClick = e => window.showAppInfo(e.target.value.name, 'Double clicked');

  onCreateMenuItems = item => [
    <Button key="0" iconName="user">{item.name}&#39;s profile</Button>,
    <Button key="1" iconName="help">Help</Button>,
    <Button key="2" iconName="disable">Don&#39;t worry</Button>,
    <Button key="3" iconName="success">Be happy!</Button>,
  ];

  onSelectionChanged = e => this.setState({ selection: e.target.value });

  // On this itemEditor example, if colIndex === 2, the cell won't be editable (return false)
  itemEditor = (item, columnName, colIndex) => {
    if (this.state.__editable && colIndex !== 2) {
      return <Input clearable={false} value={this.state.input || item[columnName]} onChange={this.onInputChange} onKeyUp={this.onKeyUp} autoFocus/>;
    }
    return false;
  };

  onEditCompleted = () => this.setState({input: null});

  onInputChange = e => this.setState({ input: e.target.value});

  // This is an example to cancel editing when pressing 'ESC' using refs to the child instance
  onKeyUp = e => {
    if (e.key === 'Escape') {
      this.refCell.current.onEditCancelled();
      this.setState({input: null});
    }
  };

  hasMore = () => true;

  loadMore = () => this.setState({
    items: this.state.items.concat(this.createItems()),
  });

  pageStart = () => this.state.items.length;

  createItems = () => {
    const items = [];

    for (let i = 0; i < 10; i++) {
      items.push({
        name: 'Ketil Hunn',
        address: 'Torgny Segerstedts vei 17, 5143 Fyllingsdalen',
        'e-mail': 'ketil.hunn@vimond.com'
      }, {
        name: 'Sondre Johanessen',
        address: 'Wergelandsbakken 11, 5067 Bergen',
        'e-mail': 'sondre@vimond.com'
      }, {
        name: 'Marius Skaar Ludvigsen',
        address: 'Ramsøyvegen 205, 5310 Hauglandshella',
        'e-mail': 'marius@vimond.com'
      });
    }
    return items;
  };

  render() {
    const { __editable, ...rest } = this.state;

    return (
      <Example {...this.props} onClick={this.onClearSelection} data-clearselection={true}>
        <Properties onChange={this.onChange} defaultProps={Table.defaultProps} propTypes={Table.propTypes} propValues={this.state}>
          <Tip>
            Use className <span className="string">scrollable</span> when you want to enable infinite scrolling for the
            table. This requires column widths to be set for all columns
          </Tip>
          <Tip>Try setting <em>selectionType</em> to <span className="string">single</span> or <span className="string">multiple</span> to try out different selection types.</Tip>
        </Properties>
        <div className="example">
          <Table {...rest} onCreateMenuItems={this.onCreateMenuItems} onClick={this.onClick}
            hasMore={this.hasMore} loadMore={this.loadMore} pageStart={this.pageStart}
            onSelectionChanged={this.onSelectionChanged} onDoubleClick={this.onDoubleClick}
            itemEditor={this.itemEditor} onEditCompleted={this.onEditCompleted} ref={this.refCell} />
            <Checkbox label="Editable (first and second column)" onChange={this.onChangeEditable} checked={__editable}/>
        </div>
        <SourceCode querySelector=".table-example .example .core-table"/>
      </Example>
    );
  }

}

TableExample.tags = 'infinite scroll';

export default TableExample;
